import React from 'react';
import Type from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { ru } from 'locale';
import useStyles from './ContragentInfo.styles';

const ContragentInfo = props => {
  const { requisites } = props;
  const classes = useStyles();

  return (
    <Card square>
      <CardHeader
        title={`№${requisites.anketId}, ${requisites.salesOrganization}`}
        titleTypographyProps={{
          variant: 'h6',
        }}
      />
      <Divider />
      <CardContent classes={{ root: classes.cardContent }}>
        <List aria-label={ru.aboutCompany}>
          <ListItem>
            <ListItemText primary={ru.anketNumber} secondary={requisites.anketId} />
          </ListItem>
          <ListItem>
            <ListItemText primary={ru.organization} secondary={requisites.organizationName} />
          </ListItem>
          <ListItem>
            <ListItemText primary={ru.inn} secondary={requisites.inn} />
          </ListItem>
          <ListItem>
            <ListItemText primary={ru.salesOrganization} secondary={requisites.salesOrganization} />
          </ListItem>
          <ListItem>
            <ListItemText primary={ru.contract} secondary={requisites.contract} />
          </ListItem>
          <ListItem button>
            <ListItemText primary={ru.generalDirector} secondary={requisites.directorName} />
          </ListItem>
          <ListItem button>
            <ListItemText
              primary={ru.founders}
              secondary={requisites.founders.map((founder, idx) => (
                /* eslint-disable-next-line react/no-array-index-key */
                <span key={idx} className={classes.listItem}>
                  {founder}
                </span>
              ))}
            />
          </ListItem>
          <ListItem button>
            <ListItemText primary={ru.dateRegistration} secondary={requisites.dateRegistration} />
          </ListItem>
          <ListItem button>
            <ListItemText primary={ru.creditLimit} secondary={requisites.creditLimit} />
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
};

ContragentInfo.propTypes = {
  requisites: Type.shape({
    anketId: Type.number.isRequired,
    inn: Type.string.isRequired,
    contract: Type.string,
    organizationName: Type.string.isRequired,
    salesOrganization: Type.string.isRequired,
    dateRegistration: Type.string.isRequired,
    founders: Type.arrayOf(Type.string.isRequired),
    directorName: Type.string,
    creditLimit: Type.string,
  }).isRequired,
};

export default ContragentInfo;
